import { render, staticRenderFns } from "./EditCommunicationTemplateEmailForm.vue?vue&type=template&id=4cbb2bce&scoped=true&"
import script from "./EditCommunicationTemplateEmailForm.vue?vue&type=script&lang=js&"
export * from "./EditCommunicationTemplateEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCommunicationTemplateEmailForm.vue?vue&type=style&index=0&id=4cbb2bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb2bce",
  null
  
)

export default component.exports